require('./dist/angular-jwt.js');
module.exports = 'angular-jwt';




//////////////////
// WEBPACK FOOTER
// ./~/angular-jwt/index.js
// module id = 479
// module chunks = 1